import { useEffect } from "react";

import { useIsDesktop } from "~/shared/lib/use-media-query";
import { useChatUIStore } from "~/shared/store/useChatUIStore";

// На десктопе SettingsPanel должна быть открыта по умолчанию,
// на mobile — закрыта. Срабатывает при изменении media-query.
export function useAutoOpenSettingsOnDesktop(): void {
    const isDesktop = useIsDesktop();
    const setSettingsPanelOpen = useChatUIStore((s) => s.setSettingsPanelOpen);

    useEffect(() => {
        setSettingsPanelOpen(isDesktop);
    }, [isDesktop, setSettingsPanelOpen]);
}
